<template>
  <div v-if="rentalUnit">
    <ion-card
      @click="
        showPreview
          ? goToPreview(rentalUnit.publicId ? rentalUnit.publicId : (rentalUnit._id as string))
          : null
      "
      class="border-default no-shadow rental-card ion-no-margin bg-white"
      color="light"
    >
      <div v-if="status" class="tag-status">
        <TagStatus :title="t(`status.${status}`)" :status="status" />
      </div>
      <img
        class="rental-card-img"
        :src="image !== '' ? image : 'https://st-web.lodgerin.com/images/image-not-found.webp'"
        alt=""
      />
      <ion-card-header>
        <ion-card-title
          ><h1 class="font-md bold-medium">{{ name }}</h1></ion-card-title
        >
        <ion-card-title class="mt-xs font-xs text-grey">
          <span>{{ rentalUnit.Property?.Location?.fullAddress }}</span></ion-card-title
        >
      </ion-card-header>
      <ion-card-content v-if="showCost">
        <SubtitleInformation :rental-unit="rentalUnit" />
      </ion-card-content>
      <ion-card-content v-if="currentBooking" class="mt-8">
        <div class="d-flex align-center">
          <ion-icon :icon="calendarOutline" color="grey" size="small" />
          <span class="pa-md text-small">{{
            formatDateTime(currentBooking?.startDate as string, locale, true, true)
          }}</span>
          <span>-</span>
          <span class="pa-md text-small">{{
            formatDateTime(currentBooking?.endDate as string, locale, true, true)
          }}</span>
        </div>
        <ion-list
          v-if="currentBooking.status === 'accepted'"
          class="show-booking-border bg-white mt-xs"
        >
          <ion-item color="white" class="d-flex gap-xs w-100">
            <div>
              <div class="info-btn" :style="`background-color: var(--ion-color-primary-tint)`">
                <ion-icon :icon="alertCircle" color="primary" class="info-icon"></ion-icon>
              </div>
            </div>
            <p class="pl-xs font-xxs">
              {{ t('bookingDetails.invoiceMessage1') }}
              <b class="primary">{{ t('bookingDetails.invoiceMessageBold') }}</b>
              {{ t('bookingDetails.invoiceMessage2') }}
            </p>
          </ion-item>
        </ion-list>
        <ion-list class="show-booking-border bg-white">
          <ion-item color="white">
            <ion-button
              @click="router.push({ name: 'Bookings', params: { bookingId: currentBooking?.id } })"
              fill="outline"
              expand="block"
              size="default"
              color="primary"
              class="text-lg text-weight-bold w-100"
            >
              {{ t('bookingDetails.showBookingDetails') }}
            </ion-button>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </div>
</template>

<script setup lang="ts">
  import {
    IonCardTitle,
    IonCardHeader,
    IonCard,
    IonCardContent,
    IonIcon,
    IonItem,
    IonList,
    IonButton,
  } from '@ionic/vue';
  import router from '@/router';
  import SubtitleInformation from './announcement/SubtitleInformation.vue';
  import { RentalUnit } from '@/interfaces/elastic/elastic.interface';
  import TagStatus from './booking/TagStatus.vue';
  import { useI18n } from 'vue-i18n';
  import { BookingForm } from '@/interfaces/booking/booking.interface';
  import { alertCircle, calendarOutline } from 'ionicons/icons';
  import { formatDateTime } from '@/utils/validations/date-utils';

  withDefaults(
    defineProps<{
      name: string;
      image: string;
      rentalUnit: RentalUnit;
      currentBooking?: BookingForm;
      status?: string;
      showCost?: boolean;
      showPreview?: boolean;
    }>(),
    {
      showCost: true,
      showPreview: true,
    },
  );

  const goToPreview = (idRental: string) => {
    router.push({ name: 'AnnouncementPage', params: { rentalId: idRental } });
  };
  const { t, locale } = useI18n();
</script>

<style lang="css" scoped>
  .show-booking-border {
    margin-top: 5px;
    border-top: 1px solid var(--ion-color-light);
  }

  .rental-card {
    cursor: pointer;
  }

  .rental-card-img {
    height: 240px;
    width: 100%;
    object-fit: cover;
  }

  ion-card.ion-color .ion-inherit-color,
  ion-card-header.ion-color .ion-inherit-color {
    color: inherit;
    padding-bottom: 0 !important;
  }

  .tag-status {
    position: relative;
    margin-top: -40px;
    top: 40px;
  }
</style>
